import React from 'react';
import { Navigate } from 'react-router-dom-v5-compat';

import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { useCurrentUser } from '~/hooks/useCurrentUser';
import { getLandingPage } from '~/permissions/rbac/getLandingPage';

const Page = () => {
  const user = useCurrentUser();
  const searchAsHomePage = useFlag(FlagType.SearchAsHomePage);
  const landing = getLandingPage(
    user.role_uuid?.permissions || [],
    user.client,
  );

  if (searchAsHomePage && landing === '/documents')
    return <Navigate to="/search" replace />;

  return <Navigate to={landing} replace />;
};

export default Page;
